import * as React from 'react';

import ImageListItem from '@mui/material/ImageListItem';

export type GalleryImageProps = {
    src: any,
    title?: string,
    cols?: number,
    rows?: number,
    size?: number,
    lowRes?: boolean,
    onClick?: any,
  };
  
  const defaultProps = {
    cols: 1,
    rows: 1,
    size: 100,
  }

function srcUrl(image: any, size: number, rows: number = 1, cols: number = 1) {
    return `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`;
}

function srcSetUrl(image: any, size: number, rows: number = 1, cols: number = 1) {
    return `${srcUrl(image, size, rows, cols)}&dpr=2 2x`;
}

function onClickHandler(props: GalleryImageProps) {
    return props.onClick ? {onClick: props.onClick} : {}
}

export default function GalleryImage(props: GalleryImageProps) {
    const cols = props.cols ? props.cols : defaultProps.cols;
    const rows = props.rows ? props.rows : defaultProps.rows;
    const size = props.size ? props.size : defaultProps.size;
    return (
        <ImageListItem key={props.src} cols={cols} rows={rows}>
            <img
                src={srcUrl(props.src, size, rows, cols)}
                srcSet={srcUrl(props.src, size, rows, cols)}
                alt={props.title ? props.title : ""}
                loading="lazy"
                {...onClickHandler(props)}
            />
        </ImageListItem>
    );
}